import { WifiCallingBanner } from './wifi-calling-banner'

export default WifiCallingBanner
